export const urlConstants={
    LOGIN:'/user/login',
    REGISTER:'/user/register',
    BANNER:'/banners',
    LEAD:'/lead/register',
    PROJECTS:'/projects',
    FORGOTPASSWORD: '/forgotpassword',
    SEND_OTP : '/user/forgot-password',
    RESET_PASSWORD : '/user/verification-set-password'
}